<template>
    <div>
        <quality-notification-component v-for="qualityNotification in this.qualityNotifications" :key="qualityNotification.Id"
        :qualityNotification="qualityNotification"
        ></quality-notification-component>
    </div>
</template>

<script>
import QualityNotificationComponent from './QualityNotificationComponent.vue';
export default {
  components: { QualityNotificationComponent },
    name: 'QualityNotificationsOverview',
    props: {
        qualityNotifications: Array
    },
}
</script>